// extracted by mini-css-extract-plugin
export default {"down-arrow":"Cta_down-arrow__KZO4s","jumpInfinite":"Cta_jumpInfinite__pxhoi","cta":"Cta_cta__eR1fX","hand-drawn":"Cta_hand-drawn__4kJeB"};